import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { BrandTokens } from "../../../@tokens/BrandTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";


export const defaultTypes: any = {
    theme: {

        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        inputWrapper: {
            backgroundColor: 'transparent',
            //minWidth: '276px',
            height: '56px',
            borderRadius: GlobalTokens.BorderRadiusMd,
            border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorLowDark}`,
            padding: `${GlobalTokens.SpacingSizeXxxs}`
        },

        inputDDIWrapper: {
            backgroundColor: 'transparent',
            maxWidth: '25%',
            height: '56px',
            borderRadius: GlobalTokens.BorderRadiusMd,
            border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorLowDark}`,
            padding: `${GlobalTokens.SpacingSizeXxxs}`
        },


        input: {
            color: BrandTokens.NeutralColorLowDark,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightRegular,
            fontSize: GlobalTokens.FontSizeXs,
            fontFamily: BrandTokens.FontFamily,
            textAlign: 'left'
        },

        icon: {
            paddingLeft: GlobalTokens.SpacingSizeXxxs
        },

        label: {
            color: BrandTokens.NeutralColorLowPure,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightMedium,
            fontSize: GlobalTokens.FontSizeXs,
            fontFamily: BrandTokens.FontFamily,
            paddingBottom: GlobalTokens.SpacingSizeNano,
            textAlign: 'left'
        },
        placeholder: {
            color: hexToRGB(BrandTokens.NeutralColorLowDark, GlobalTokens.OpacityLevelIntense)
        },
        helper: {
            alignItems: 'center',
            marginTop: GlobalTokens.SpacingSizeNano,
            color: BrandTokens.NeutralColorLowDark,
            fontSize: GlobalTokens.FontSizeXxs,
            fontWeight: BrandTokens.FontWeightRegular,
            fontFamily: BrandTokens.FontFamily,
            lineHeight: GlobalTokens.LineHeightDefault,
            icon: {
                paddingRight: GlobalTokens.SpacingSizeQuarck
            }
        },

        states: {
            hover: {
                inputWrapper: {
                    backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium)
                }
            },
            focus: {
                border: `${GlobalTokens.BorderWidthThin} solid ${BrandTokens.HighlightColorPure}`,
                borderRadius: GlobalTokens.BorderRadiusSm,
                inputWrapper: {
                    backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium)
                }
            },
            actived: {
                label: {
                    color: BrandTokens.BrandColorPrimaryPure
                },
                inputWrapper: {
                    borderColor: BrandTokens.BrandColorPrimaryPure
                }
            },
            error: {
                label: {
                    color: BrandTokens.FeedbackColorErrorPure
                },
                inputWrapper: {
                    borderColor: BrandTokens.FeedbackColorErrorPure,
                    backgroundColor: BrandTokens.FeedbackColorErrorLight
                },
                helper: {
                    color: BrandTokens.FeedbackColorErrorPure
                }
            },
            disabled: {
                label: {
                    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                },
                inputWrapper: {
                    borderColor: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium),
                    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                },
                placeholder: {
                    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                },
                helper: {
                    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                }
            }
        }
    }
}